import { useEffect } from 'react';
import { noop } from 'lodash';
import { stats } from '@fiverr-private/obs';
import { STATS_PREFIX, INTERSECTION_OBSERVER_UNDEFINED } from '../../../../constants';

const useObserver = ({ observableRef = null, onObserve = noop }) => {
    useEffect(() => {
        const initObserver = () => {
            if (!window.IntersectionObserver) {
                stats.count(STATS_PREFIX, INTERSECTION_OBSERVER_UNDEFINED);
                return;
            }

            if (!observableRef) {
                throw new Error('observableRef is not defined');
            }

            const observeTarget = observableRef.current;
            if (!observeTarget) {
                return;
            }

            const observer = new IntersectionObserver((entries) => {
                if (entries[0].intersectionRatio <= 0) {
                    return;
                }

                onObserve();
                observer.unobserve(observeTarget);
            });

            observer.observe(observeTarget);

            return () => observer.disconnect();
        };

        return initObserver();

        // onObserve is not a dependency to prevent multiple subscriptions due to redeclaration of it
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [observableRef]);

    return observableRef;
};

export default useObserver;
